/** English bar-graph prompts and chart category vocabulary (ADR 0051 part 3). */
export const barGraphPrompts = {
    total: () => `What is the total of every bar added together?`,
    largest: () => `Which category has the most?`,
    difference: (larger: string, smaller: string) => `How many more does ${larger} have than ${smaller}?`,
    readOne: (label: string) => `How many does the graph show for ${label}?`,
};

/**
 * Small, fixed vocabularies so a chart's categories read like a real one
 * rather than "A, B, C, D" (see BarGraphGenerator.ts). Unchanged from the
 * original inline English lists.
 */
export const barGraphLabelSets: { labels: string[]; sequential: boolean }[] = [
    { labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'], sequential: true },
    { labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'], sequential: true },
    { labels: ['Red', 'Blue', 'Green', 'Yellow', 'Purple', 'Orange'], sequential: false },
    { labels: ['Pear', 'Plum', 'Kiwi', 'Fig', 'Mango', 'Grape'], sequential: false },
    { labels: ['Golf', 'Chess', 'Track', 'Swim', 'Tennis', 'Skate'], sequential: false },
];
